define('views/howto/howto',[
    'backbone',
    'views/_base/baseview',
    'text!views/howto/howto.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'profile-content',
        tagName  : 'div',
        isRender : true,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){},

        close: function(){}
    });
});

